<template>
  <select-create
    :model="model"
    :columns="columns"
    createApi="Contacts/Create"
    :createModel="formModel"
    :data="dataSource.records"
    :isLoading="dataSource.isLoading"
    :fields="{id: 'id', title: 'name'}"
    :disabled="isDisabled"
    v-bind="$attrs"
    v-on="$listeners"
    @validate="handlerValidate"
    @on-created="handlerCreated"
  >
    <template v-slot:form="{ change, data }">
      <create-form ref="form" :model="formModel" :data="data" @change="change"></create-form>
    </template>
  </select-create>
</template>

<script>
import { api } from '@/services/api'
const L10n = window.app.L10n
export default {
  name: 'SelectCompanyContact',
  components: {
    'select-create': () => import(/* webpackChunkName: 'Shared' */ '@/components/Form/UI/Selects/SelectCreate/Index'),
    'create-form': () => import(/* webpackChunkName: 'Shared' */ './Form.vue')
  },
  props: {
    companyID: { required: true },
    model: { required: true },
    disabled: { type: Boolean, default: false },
    columns: {
      type: Array,
      default: () => (
        [
          { title: L10n('name'), value: 'name' },
          { title: L10n('email'), value: 'email' },
          { title: L10n('division'), value: 'divisionTitle' },
          { title: L10n('remark'), value: 'remark' }
        ]
      )
    }
  },
  watch: {
    companyID: {
      immediate: true,
      handler: '_changeCompanyID'
    }
  },
  data () {
    return {
      delayUpdateValue: 300,
      dataSource: {
        map: [],
        records: [],
        isLoading: false
      }
    }
  },
  computed: {
    isDisabled () {
      return this.disabled || !this.companyID
    }
  },
  methods: {
    formModel () {
      return {
        companyID: this.companyID,
        name: '',
        email: '',
        divisionID: null,
        title: '',
        phone: '',
        mobile: '',
        remark: ''
      }
    },
    _changeCompanyID (companyID) {
      this.updateDataSource()
    },
    updateDataSource () {
      let promise = this.companyID
        ? this._requestGetDataSource()
        : Promise.resolve({ value: [] })
      return promise
        .then((data) => {
          this.dataSource.records = data.value
          this.dataSource.map = data.value.reduce((result, item) => {
            result[item.id] = item
            return result
          }, {})
        })
    },
    _requestGetDataSource () {
      this.dataSource.isLoading = true
      return api
        .get(`Contacts/GetAllDynamic`, { params: this._createParams() })
        .then((response) => {
          this.dataSource.isLoading = false
          return response.data
        })
    },
    _createParams () {
      return {
        'select': `id,name,email,division.title as divisionTitle,remark`,
        'filter': `companyID == ${this.companyID}`,
        'orderBy': 'id desc'
      }
    },
    handlerCreated () {
      this.updateDataSource()
    },
    handlerValidate (callback) {
      this.$refs.form.validate()
        .then(() => {
          callback()
        })
        .catch(() => {
          callback(new Error('invalid part form'))
        })
    }
  }
}
</script>
